import { Dispatch, SetStateAction, useContext } from 'react';

import { ToadMessage } from 'utils/types';

import { CopilotContext } from './Copilot';

export type CopilotState = {
  [key: string]: any;
  open?: boolean;
  activeConversation?: { topic: string; conversationId: string };
  messages: ToadMessage[];
  mode: 'search' | 'chat';
};

export type TCopilotContext = {
  mode: 'search' | 'chat';
  topic?: string;
  setTopic: Dispatch<SetStateAction<string>>;
  selectedConversation?: string;
  toggleCopilotSidebar: () => void;
  newChat: () => void;
  setSelectedConversation: Dispatch<SetStateAction<undefined | string>>;
  messages: ToadMessage[];
  toggleMode: () => void;
  isLoading: boolean;
  module?: '' | 'leads' | 'deals';
  recordId?: string;
};
const useCopilotContext = () => useContext<TCopilotContext>(CopilotContext);

export default useCopilotContext;
